const doc = [({"zh_cn":({"adminComponentHotelChildrenSetting":({"addCategory":"添加类别", "editCategory":"编辑类别", "hotelChildrenSettingTitle":"儿童设置", "notesTitle":"儿童注意事项"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;